<script>
  export let size=""
  export let mode=""
  export let elem=null
</script>

<button {...$$props} bind:this={elem} on:click on:mousedown class={"sbtn "+(size ? size+" " : "")+(mode ? mode+" " : "")}>
  <slot></slot>
</button>

<style>
  .sbtn{
    position: relative;
    box-sizing: border-box;
    padding:7px 12px;
    background:#fff;
    border:0px;
    font-size: 14px;
    text-decoration: none;
    color:black;
    white-space: nowrap;
    display: inline-block;
    margin:var(--s-button-margins,4px);
    text-align: center;
    cursor: pointer;
    line-height:1.25;
    border-radius:var(--s-border-radius,4px);
    box-shadow:0 0 2px rgba(0,0,0,0.5),0 0px 0px rgba(0,0,0,0.1);
    transition:box-shadow 0.2s;
    line-height:1.428571429;
  }
  .sbtn:disabled{
    opacity:0.5;
    cursor:not-allowed;
  }
  .sbtn:disabled:hover{
    box-shadow:0 0 2px rgba(0,0,0,0.1),0 0px 0px rgba(0,0,0,0.1);
  }
  .sbtn:hover{box-shadow:0 0 4px rgba(0,0,0,0.5),0 0px 0px rgba(0,0,0,0.2);} 
  .sbtn:focus{outline:0px;box-shadow:0 0 3px rgba(0,0,0,0.5)}
  .sbtn:active{ outline:0px; box-shadow:inset 0 4px 4px rgba(0,0,0,0.2);} 
  .xs{font-size:10px; padding:2px 7px;}
  .sm{font-size:12px; padding:4px 10px;}
  .lg{font-size:21px; padding:10px 20px;}
  .block{display:block;width:100%;}

  .primary,.info,.success,.warning,.danger,.dark{
    color:white;
    box-shadow:0 0 2px rgba(0,0,0,0.1),0 0px 0px rgba(0,0,0,0.1);
  }   
  .primary{background-color:#2299ee; background-color:var(--s-primary,#2299ee)}
  .info{background-color:#17a2b8; background-color:var(--s-info,#17a2b8)}
  .success{background-color:#28a745; background-color:var(--s-success,#28a745)}
  .warning{background-color:#ffc107; background-color:var(--s-warning,#ffc107)}
  .danger{background-color:#dc3545; background-color:var(--s-danger,#dc3545)}
  .dark{background-color:#343a40; background-color:var(--s-dark,#343a40)}
</style>